"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Pill = exports.PillTypes = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var BootstrapHelper_1 = require("../../BootstrapHelper");
var enums_1 = require("../../enums");
var PillTypes;
(function (PillTypes) {
    PillTypes["PRIMARY"] = "primary";
    PillTypes["SECONDARY"] = "secondary";
    PillTypes["TERTIARY"] = "tertiary";
    PillTypes["OUTLINE_PRIMARY"] = "outline-primary";
    PillTypes["OUTLINE_SECONDARY"] = "outline-secondary";
    PillTypes["OUTLINE_TERTIARY"] = "outline-tertiary";
    PillTypes["INDICATOR_ACCENT_0"] = "indicator-accent-0";
    PillTypes["INDICATOR_ACCENT_1"] = "indicator-accent-1";
    PillTypes["INDICATOR_ACCENT_2"] = "indicator-accent-2";
    PillTypes["INDICATOR_ACCENT_3"] = "indicator-accent-3";
    PillTypes["SUCCESS"] = "success";
    PillTypes["WARNING"] = "warning";
    PillTypes["DANGER"] = "danger";
    PillTypes["OUTLINE_SUCCESS"] = "outline-success";
    PillTypes["OUTLINE_WARNING"] = "outline-warning";
    PillTypes["OUTLINE_DANGER"] = "outline-danger";
    PillTypes["WHITE"] = "white";
    PillTypes["BLACK"] = "black";
    PillTypes["LIGHT_GRAY"] = "light-gray";
    PillTypes["GRAY"] = "gray";
    PillTypes["OUTLINE_BLACK"] = "outline-black";
    PillTypes["OUTLINE_LIGHT_GRAY"] = "outline-light-gray";
    PillTypes["OUTLINE_GRAY"] = "outline-gray";
})(PillTypes = exports.PillTypes || (exports.PillTypes = {}));
var Pill = function (props) {
    var type = props.type, size = props.size, onClick = props.onClick, children = props.children;
    var cls = (0, BootstrapHelper_1.B)()
        .bl("pill")
        .pmod(type || PillTypes.PRIMARY)
        .pmod(size || enums_1.UiSizes.SM).bem;
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, props, { className: "".concat(cls, " align-self-start ").concat(props.className || ""), onClick: onClick, style: props.style }, { children: children })));
};
exports.Pill = Pill;
